import { blogNav } from './blogNav.js';

function init() {
    blogNav();
}

export {
    init   
}